import { PlusOutlined } from "@ant-design/icons";
import { Button, Divider } from "antd";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import SearchFilterCard from "../../components/general/filter-card";
import PageHeader from "../../components/general/layout/page-header";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import AppContext from "../../context/app/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import {Permissions} from "../../utils/Permissions/Permissions";
import styles from "./style.module.scss";
import SliceContext from "../../context/slice/context";
import SliceContextProvider from "../../context/slice/provider";
import SliceTable from "../../components/slice/slice-table";
interface IProps {
  children?: React.ReactNode;
}

const Slice: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const navigate = useNavigate();
  const [search, setSearch] = useState<string | undefined>(undefined);

  const { actions, loading, query } = useContext(SliceContext);

  useEffect(() => {
    actions.setSearch(search);
  }, [search]);

  const isMounted = useIsMount();
  useEffect(() => {
    !isMounted && actions.getData();
  }, [query, direction]);
  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("slices")}
        subTitle={t("slices_management")}
        extra={[
          <RefreshBtn
            key={0}
            loading={loading.includes("list")}
            onClick={() => actions.getData()}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Divider key={1} type="vertical" />,
          <Can key={2} perform={Permissions.CAN_CREATE_SLICE}>
            <Button
              type="primary"
              onClick={() => {
                navigate(`/slices/create`);
              }}
              icon={<PlusOutlined />}
            >
              {t("add_slice")}
            </Button>
          </Can>,
        ]}
      />

      <SearchFilterCard
        formId="slice-filter"
        searchValue={search}
        setSearchValue={setSearch}
        onReset={() => {
          actions.setQuery({
            page: query?.page,
            perPage: query?.perPage,
          });
          const form = document.getElementById("slice-filter");
          if (form) {
            form.dispatchEvent(new Event("reset", { cancelable: true, bubbles: true }));
          }
        }}
        resetLoading={loading.includes("list")}
        applyLoading={loading.includes("list")}
      ></SearchFilterCard>

      <SliceTable />
    </div>
  );
};

const SlicePage = () => {
  return (
    <SliceContextProvider>
      <Slice />
    </SliceContextProvider>
  );
};
export default SlicePage;
